export type DocumentationResource = 'docs' | 'developer' | 'policies';

/**
 * Create a documentation URL for a given path.
 */
export function createDocumentationURL(path: string, host: DocumentationResource = 'docs'): string {
    return `https://${getResourceHost(host)}/${path.replace(/^\//, '')}`;
}

/**
 * Return the hostname for a given documentation resource.
 */
function getResourceHost(resource: DocumentationResource): string {
    switch (resource) {
        case 'docs':
            return 'gitbook.com/docs';
        case 'developer':
            return 'developer.gitbook.com';
        case 'policies':
            return 'policies.gitbook.com';
    }
}
